import { useCallback, useMemo } from "react"
import { useAuth } from "@/features/auth/hooks/useAuth"
import { authStore } from "@/store/auth"

/**
 * Hook para verificação de autorização admin
 */
export function useAdminAuth() {
  const { user } = useAuth()
  const isImpersonating = authStore(s => s.isImpersonating)
  const impersonatorId = authStore(s => s.impersonatorId)

  const isAdmin = useMemo(() => {
    if (isImpersonating && impersonatorId) return true
    return user?.roles?.includes("admin") || false
  }, [user, isImpersonating, impersonatorId])

  const requireAdmin = useCallback(() => {
    if (!isAdmin) {
      throw new Error("Access denied: admin role required")
    }
  }, [isAdmin])

  return {
    isAdmin,
    requireAdmin,
    user,
  }
}
